import React, { useState } from 'react';
import { Plane, Building2, User, CheckCircle, ArrowRight, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
export function RegisterPage() {
  const [step, setStep] = useState(1);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (step < 3) {
      setStep(step + 1);
    } else {
      setIsSuccess(true);
    }
  };
  if (isSuccess) {
    return <div className="min-h-screen w-full flex items-center justify-center bg-slate-900 relative overflow-hidden" data-id="element-2235">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-2236"></div>
        <div className="relative w-full max-w-md p-6 text-center" data-id="element-2237">
          <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-emerald-500/20 text-emerald-500" data-id="element-2238">
            <CheckCircle className="h-10 w-10" data-id="element-2239" />
          </div>
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-2240">
            Account Created!
          </h2>
          <p className="text-slate-400 mb-8" data-id="element-2241">
            We've sent a verification email to your inbox. Please click the link
            to verify your account and start setting up your organization.
          </p>
          <Link to="/login" className="inline-flex items-center justify-center rounded-lg bg-blue-600 px-8 py-3 text-sm font-medium text-white hover:bg-blue-700 transition-colors" data-id="element-2242">
            Return to Login
          </Link>
        </div>
      </div>;
  }
  return <div className="min-h-screen w-full flex items-center justify-center bg-slate-900 relative overflow-hidden" data-id="element-2243">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-2244"></div>

      <div className="relative w-full max-w-lg p-6" data-id="element-2245">
        <div className="mb-8 text-center" data-id="element-2246">
          <div className="mx-auto mb-4 flex h-16 w-auto items-center justify-center" data-id="element-2247">
            <img src="https://cdn.magicpatterns.com/uploads/76CAA7KBYMWEPu97mZSYz3/Untitled_design.png" alt="Super International Travels Limited" className="h-full w-auto max-w-[240px] object-contain" data-id="element-2248" />
          </div>
          <h1 className="text-2xl font-bold text-white" data-id="element-2249">
            Create Organization Account
          </h1>
          <p className="mt-2 text-slate-400" data-id="element-2250">Step {step} of 3</p>
        </div>

        <div className="rounded-2xl bg-white p-8 shadow-2xl" data-id="element-2251">
          {/* Progress Steps */}
          <div className="flex items-center justify-between mb-8 relative" data-id="element-2252">
            <div className="absolute left-0 top-1/2 h-0.5 w-full -translate-y-1/2 bg-slate-100 -z-10" data-id="element-2253"></div>
            <div className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-medium transition-colors ${step >= 1 ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-400'}`} data-id="element-2254">
              1
            </div>
            <div className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-medium transition-colors ${step >= 2 ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-400'}`} data-id="element-2255">
              2
            </div>
            <div className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-medium transition-colors ${step >= 3 ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-400'}`} data-id="element-2256">
              3
            </div>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2257">
            {step === 1 && <div className="space-y-4 animate-in fade-in slide-in-from-right-4 duration-300" data-id="element-2258">
                <div className="text-center mb-6" data-id="element-2259">
                  <h3 className="text-lg font-semibold text-slate-900" data-id="element-2260">
                    Organization Details
                  </h3>
                  <p className="text-sm text-slate-500" data-id="element-2261">
                    Tell us about your company
                  </p>
                </div>

                <div data-id="element-2262">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2263">
                    Company Name
                  </label>
                  <div className="relative" data-id="element-2264">
                    <Building2 className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" data-id="element-2265" />
                    <input type="text" required className="block w-full rounded-lg border border-slate-300 pl-10 p-2.5 focus:border-blue-500 focus:ring-blue-500" placeholder="Acme Corp" data-id="element-2266" />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4" data-id="element-2267">
                  <div data-id="element-2268">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2269">
                      Industry
                    </label>
                    <select className="block w-full rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" data-id="element-2270">
                      <option data-id="element-2271">Technology</option>
                      <option data-id="element-2272">Finance</option>
                      <option data-id="element-2273">Healthcare</option>
                      <option data-id="element-2274">Manufacturing</option>
                      <option data-id="element-2275">Retail</option>
                    </select>
                  </div>
                  <div data-id="element-2276">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2277">
                      Company Size
                    </label>
                    <select className="block w-full rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" data-id="element-2278">
                      <option data-id="element-2279">1-10</option>
                      <option data-id="element-2280">11-50</option>
                      <option data-id="element-2281">51-200</option>
                      <option data-id="element-2282">201-500</option>
                      <option data-id="element-2283">500+</option>
                    </select>
                  </div>
                </div>

                <div data-id="element-2284">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2285">
                    Headquarters Country
                  </label>
                  <select className="block w-full rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" data-id="element-2286">
                    <option data-id="element-2287">United States</option>
                    <option data-id="element-2288">United Kingdom</option>
                    <option data-id="element-2289">Canada</option>
                    <option data-id="element-2290">Germany</option>
                    <option data-id="element-2291">France</option>
                    <option data-id="element-2292">Japan</option>
                  </select>
                </div>
              </div>}

            {step === 2 && <div className="space-y-4 animate-in fade-in slide-in-from-right-4 duration-300" data-id="element-2293">
                <div className="text-center mb-6" data-id="element-2294">
                  <h3 className="text-lg font-semibold text-slate-900" data-id="element-2295">
                    Admin Account
                  </h3>
                  <p className="text-sm text-slate-500" data-id="element-2296">
                    Create your administrator profile
                  </p>
                </div>

                <div data-id="element-2297">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2298">
                    Full Name
                  </label>
                  <div className="relative" data-id="element-2299">
                    <User className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" data-id="element-2300" />
                    <input type="text" required className="block w-full rounded-lg border border-slate-300 pl-10 p-2.5 focus:border-blue-500 focus:ring-blue-500" placeholder="John Doe" data-id="element-2301" />
                  </div>
                </div>

                <div data-id="element-2302">
                  <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2303">
                    Work Email
                  </label>
                  <input type="email" required className="block w-full rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" placeholder="john@company.com" data-id="element-2304" />
                </div>

                <div className="grid grid-cols-2 gap-4" data-id="element-2305">
                  <div data-id="element-2306">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2307">
                      Password
                    </label>
                    <input type="password" required className="block w-full rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" placeholder="••••••••" data-id="element-2308" />
                  </div>
                  <div data-id="element-2309">
                    <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-2310">
                      Confirm
                    </label>
                    <input type="password" required className="block w-full rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" placeholder="••••••••" data-id="element-2311" />
                  </div>
                </div>
              </div>}

            {step === 3 && <div className="space-y-6 animate-in fade-in slide-in-from-right-4 duration-300" data-id="element-2312">
                <div className="text-center mb-6" data-id="element-2313">
                  <h3 className="text-lg font-semibold text-slate-900" data-id="element-2314">
                    Review & Submit
                  </h3>
                  <p className="text-sm text-slate-500" data-id="element-2315">
                    Please verify your information
                  </p>
                </div>

                <div className="rounded-lg bg-slate-50 p-4 space-y-3 text-sm" data-id="element-2316">
                  <div className="flex justify-between border-b border-slate-200 pb-2" data-id="element-2317">
                    <span className="text-slate-500" data-id="element-2318">Company</span>
                    <span className="font-medium text-slate-900" data-id="element-2319">
                      Acme Corp
                    </span>
                  </div>
                  <div className="flex justify-between border-b border-slate-200 pb-2" data-id="element-2320">
                    <span className="text-slate-500" data-id="element-2321">Industry</span>
                    <span className="font-medium text-slate-900" data-id="element-2322">
                      Technology
                    </span>
                  </div>
                  <div className="flex justify-between border-b border-slate-200 pb-2" data-id="element-2323">
                    <span className="text-slate-500" data-id="element-2324">Admin</span>
                    <span className="font-medium text-slate-900" data-id="element-2325">John Doe</span>
                  </div>
                  <div className="flex justify-between" data-id="element-2326">
                    <span className="text-slate-500" data-id="element-2327">Email</span>
                    <span className="font-medium text-slate-900" data-id="element-2328">
                      john@acme.com
                    </span>
                  </div>
                </div>

                <div className="flex items-start gap-2" data-id="element-2329">
                  <input type="checkbox" required className="mt-1 h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500" data-id="element-2330" />
                  <label className="text-sm text-slate-600" data-id="element-2331">
                    I agree to the{' '}
                    <a href="#" className="text-blue-600 hover:underline" data-id="element-2332">
                      Terms of Service
                    </a>{' '}
                    and{' '}
                    <a href="#" className="text-blue-600 hover:underline" data-id="element-2333">
                      Privacy Policy
                    </a>
                  </label>
                </div>
              </div>}

            <div className="flex gap-3 pt-4" data-id="element-2334">
              {step > 1 && <button type="button" onClick={() => setStep(step - 1)} className="flex items-center justify-center rounded-lg border border-slate-300 bg-white px-5 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50" data-id="element-2335">
                  <ArrowLeft className="mr-2 h-4 w-4" data-id="element-2336" /> Back
                </button>}
              <button type="submit" className="flex flex-1 items-center justify-center rounded-lg bg-blue-600 px-5 py-2.5 text-sm font-medium text-white hover:bg-blue-700" data-id="element-2337">
                {step === 3 ? 'Create Account' : 'Next Step'}
                {step < 3 && <ArrowRight className="ml-2 h-4 w-4" data-id="element-2338" />}
              </button>
            </div>
          </form>
        </div>

        <p className="mt-6 text-center text-sm text-slate-500" data-id="element-2339">
          Already have an account?{' '}
          <Link to="/login" className="font-medium text-blue-400 hover:underline" data-id="element-2340">
            Sign in
          </Link>
        </p>
      </div>
    </div>;
}